import React from "react";
import HeaderAddExcel from "./HeaderAddExcel";
import HeaderAddAllResults from "./HeaderAddAllResults";
import HeaderMySelection from "./HeaderMySelection";

export default function ContainerHeaderAdd() {
  return (
    <React.Fragment>
      <ul className="view-nav-list view-nav-list__additional">
        <HeaderMySelection />
        <HeaderAddAllResults />
        <HeaderAddExcel />
      </ul>
    </React.Fragment>
  );
}
